import { render } from "./UCUnitMeasureKiloAndContainer.vue?vue&type=template&id=21357034&scoped=true"
import script from "./UCUnitMeasureKiloAndContainer.vue?vue&type=script&lang=js"
export * from "./UCUnitMeasureKiloAndContainer.vue?vue&type=script&lang=js"

import "./UCUnitMeasureKiloAndContainer.vue?vue&type=style&index=0&id=21357034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21357034"]])

export default __exports__